import { css } from '@emotion/core';
import { tokens, variables, media, rgba, globalTokens } from '@domain-group/fe-brary';
import { typography, truncateLines } from '@domain-group/fe-co-allhomes-design-system';
var font = variables.font,
  global = variables.global;
var colours = tokens.colors;
var desktopHeight = '211px';
var desktopPhotoSize = '56px';
var mobilePhotoSize = '54px';
export var agentCard = /*#__PURE__*/css("position:relative;display:flex;flex-direction:column;justify-content:space-between;overflow:hidden;flex-shrink:0;width:308px;border:1px solid ", colours.neutral.trim.default, ";padding:16px;gap:16px;", media('>=tablet'), "{height:", desktopHeight, ";width:324px;padding:24px;:hover{box-shadow:0 5px 40px 0 ", rgba(globalTokens.colors.black, 0.1), ";}}");
export var details = {
  name: "34osvq",
  styles: "display:flex;flex-direction:row;align-items:start;gap:16px;"
};
export var nameAndDesignation = {
  name: "i9ak0h",
  styles: "display:flex;flex-direction:column;width:calc(100% - 72px);align-items:start;"
};
export var name = /*#__PURE__*/css("color:", colours.neutral.heavy.default, ";text-decoration:none;", truncateLines(2), " ", typography.headingS, " text-align:left;&::before{position:absolute;top:0;right:0;left:0;bottom:0;z-index:2;content:'';}");
export var designation = /*#__PURE__*/css("color:", colours.neutral.medium.default, ";", truncateLines(2), " ", typography.bodySmall, " text-align:left;");
export var avatarImage = /*#__PURE__*/css("width:", mobilePhotoSize, ";height:", mobilePhotoSize, ";", media('>=tablet'), "{width:", desktopPhotoSize, ";height:", desktopPhotoSize, ";}");
export var buttons = /*#__PURE__*/css("display:flex;z-index:", global.layerPopout, ";");
export var callButton = /*#__PURE__*/css("white-space:nowrap;height:44px;margin-right:10px;font-weight:", font.headingFontWeight, ";min-width:132px;");
export var emailButton = {
  name: "1ry0z48",
  styles: "min-width:130px;"
};